<section id="testimonials" class="section section-1">

  <div class="container">

    <div class="text-center mb-5">

      <span class="section-badge">
        {{ 'testimonials.badge' | translate }}
      </span>

      <h2 class="section-title">
        {{ 'testimonials.title' | translate }}
      </h2>

      <p class="section-subtitle">
        {{ 'testimonials.subtitle' | translate }}
      </p>

    </div>

    <div class="row g-4">

      @for (testimonial of testimonials; track testimonial) {

      <div class="col-lg-6 col-md-6">

        <div class="testimonial-card d-flex flex-column align-items-center">

          <div class="stars">
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
          </div>

          <p class="testimonial-text">
            "{{ testimonial.feedback }}"
          </p>

          <div class="testimonial-user">

            <div class="avatar">
              {{ testimonial.name.charAt(0) }}
            </div>

            <div>

              <h6>
                {{ testimonial.name }}
              </h6>

              <small>
                {{ testimonial.role }}
                @if(testimonial.company){
                <span> • {{ testimonial.company }}</span>
                }
              </small>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>